import { useEffect } from 'react'

import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router-dom'

import { TAppDispatch } from '~/shared/store/types'
import { sendUserConfigAction, setUtmTags } from '~/shared/store/user'

export const useUtmTags = () => {
  const { search } = useLocation()
  const dispatch: TAppDispatch = useDispatch()
  const URLParams = new URLSearchParams(search)
  const utmTagsFromUrl = Object.fromEntries(URLParams.entries())

  useEffect(() => {
    if (utmTagsFromUrl.utm_source) {
      dispatch(setUtmTags(utmTagsFromUrl))
      dispatch(
        sendUserConfigAction({
          utm_tags: utmTagsFromUrl,
        }),
      )
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch])
}
